module.exports = __webpack_public_path__ + "images/emoji/man_with_gua_pi_mao.26955039c3e3081e4f53.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/man_with_gua_pi_mao.png
// module id = y9qn
// module chunks = 14